module.exports = __webpack_public_path__ + "static/img/super-chat-pass.8dcf5ca3.png";